import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Dialog} from "@angular/cdk/dialog";
import {DataService} from "../../../../services/data.service";
import {PromptDialogComponent} from "../../../../components/prompt-dialog/prompt-dialog.component";

@Component({
  selector: 'app-login-reset-password',
  templateUrl: './login-reset-password.component.html',
  styleUrls: ['./login-reset-password.component.scss']
})
export class LoginResetPasswordComponent implements OnInit {
  public error: string;
  public isLoading = false;

  public password: string;
  public password2: string;

  public token: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: Dialog,
    private dataService: DataService
  ) {
  }

  public ngOnInit(): void {
    this.token = this.route.snapshot.params.token;
  }

  public async login(): Promise<void> {
    if (!this.canLogin()) {
      return;
    }
    this.isLoading = true;

    try {
      const user = await this.dataService.resetPassword(this.password, this.token);
      const email = user.email;
      await this.dataService.login({email, password: this.password, rememberMe: false});
      this.route.queryParams.subscribe((params) =>
        this.router.navigate([params.redirect || 'overview'], {replaceUrl: true})
      );
    } catch (err) {
      this.dialog.open(PromptDialogComponent, {
        data: {
          title: 'Achtung!',
          body: 'Der verwendete Link ist ungültig, abgelaufen oder wurde bereits verwendet. Bitte fordern Sie einen neuen Link an.',
          confirmAction: 'Verstehen',
          closeActionEnabled: false,
        },
      });
    } finally {
      this.isLoading = false;
    }
  }

  public canLogin(): boolean {
    return this.password && this.password === this.password2 && this.password.length >= 8;
  }
}
